import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import b from 'b_';
import Icon from '../Icon/Icon';
import { FTInput } from '../Fuse';
import './FuseConsoleCardFooter.css';

const block = b.lock('FuseConsoleCardFooter');

function FuseConsoleCardFooter({ text, className, iconClassName, wrapperStyle = {} }) {
    return (
        <div className={cn(block(), className)} style={wrapperStyle}>
            <Icon type="info" className={cn(block('Icon'), iconClassName)} />
            <FTInput className={block('Text')}>{text}</FTInput>
        </div>
    );
}

FuseConsoleCardFooter.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
    wrapperStyle: PropTypes.object,
    iconClassName: PropTypes.string,
};

export default FuseConsoleCardFooter;
